import { useLayout } from 'context'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import * as controllers from 'controllers'
import { ArrowBack } from '@mui/icons-material'
import { Grid, Card, CardContent, Typography, Button } from '@mui/material'
import { VehicleNeedsThirdPartyAdditionalProgrammingDetailsDto } from 'dtos'
import { enqueueSnackbar } from 'notistack'
import Step1DeliverToThirdPartyAdditionalProgrammer from './Step1DeliverToThirdPartyAdditionalProgrammer'
import VehicleNeedsThirdPartyAdditionalProgrammingHeroCard from './VehicleNeedsThirdPartyAdditionalProgrammingHeroCard'

export default function NeedsThirdPartyAdditionalProgramming() {
  const { vehicleGuid } = useParams()
  const layout = useLayout()
  const navigate = useNavigate()

  const [initialValues, setInitialValues] = useState<VehicleNeedsThirdPartyAdditionalProgrammingDetailsDto>(
    new VehicleNeedsThirdPartyAdditionalProgrammingDetailsDto()
  )

  const [activeStep] = useState<number>(0)

  useEffect(() => {
    if (vehicleGuid) {
      layout.setIsLayoutLoading(true)
      controllers
        .getNeedsThirdPartyAdditionalProgrammingDetails(vehicleGuid)
        .then(response => {
          setInitialValues(response.value)
        })
        .finally(() => {
          layout.setIsLayoutLoading(false)
        })
    }
  }, [vehicleGuid])

  return (
    <Grid container spacing={1} alignItems='center'>
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Grid container justifyContent='space-between'>
              <Grid item>
                <Typography fontWeight='bold' variant='h5' sx={{ pr: 1 }}>
                  Needs 3rd Party Additional Programming
                </Typography>
              </Grid>

              <Grid item xs={12} sm='auto' container spacing={2} alignItems='center' justifyContent='flex-end'>
                <Grid item>
                  <Button
                    onClick={() => {
                      navigate('/to-do-list')
                    }}
                    color='primary'
                    startIcon={<ArrowBack />}
                    variant='text'
                  >
                    BACK
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12}>
        <VehicleNeedsThirdPartyAdditionalProgrammingHeroCard vehicle={initialValues} />
      </Grid>

      {activeStep === 0 && (
        <Grid item xs={12}>
          <Step1DeliverToThirdPartyAdditionalProgrammer
            needsThirdPartyAdditionalProgrammingDetails={initialValues}
            onNext={() => {
              layout.setIsLayoutLoading(true)
              controllers
                .updateNeedsThirdPartyAdditionalProgrammingDetails(vehicleGuid!, {
                  ...initialValues
                })
                .then(response => {
                  enqueueSnackbar('Delivered to Third Party Additional Programmer', { variant: 'success' })
                  setInitialValues(response.value)
                  navigate('/to-do-list', { replace: true })
                })
                .finally(() => {
                  layout.setIsLayoutLoading(false)
                })
            }}
            vehicle={initialValues}
            vehicleGuid={vehicleGuid}
          />
        </Grid>
      )}
    </Grid>
  )
}
